module.exports = {
  "conn-con8": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "copy-con9": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variantA"
      ]
    }
  },
  "acad-0027": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variation"
      ]
    }
  },
  "acad-0029": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variationA",
        "variationB",
        "variationC"
      ]
    }
  },
  "acad-0030": {
    "identifierType": "PORTAL_ID",
    "maxAge": 0,
    "parameters": {
      "group": [
        "variation1",
        "variation2",
        "variation3",
        "variation4",
        "variation5",
        "variation6",
        "variation7",
        "variation8",
        "variation9",
        "variation10",
        "variation11",
        "variation12",
        "variation13",
        "variation14",
        "variation15",
        "variation16",
        "variation17",
        "variation18",
        "variation19",
        "variation20",
        "variation21",
        "variation22",
        "variation23",
        "variation24",
        "variation25",
        "variation26",
        "variation27"
      ]
    }
  }
};